<script lang="ts" setup>
import { Event } from '@/models/Event';
import { EventOrganizer } from '@/models/EventOrganizer';
import EventOrganizerSelect from '@/components/event/EventOrganizerSelect.vue';
import { fieldRuleValue } from '@/helpers/tools';

defineProps<{
    record: Event;
}>();

const emit = defineEmits(['input']);
const eoMandatory = fieldRuleValue('field_rules.mandatory.event.organizer_id', false);

function onEventOrganizerSelect(eoRec: EventOrganizer | null) {
    if (eoRec) {
        emit('input', eoRec.id);
    } else {
        emit('input', null);
    }
}
</script>
<template>
    <LabelField :label="$t('event_organizer')">
        <EventOrganizerSelect
            :event="record"
            :required="eoMandatory"
            show-new
            @selected="onEventOrganizerSelect($event)"
        />
    </LabelField>
</template>
